import { isClient, isNumber, isString } from '@qcwp/utils'
import {
  ARTICLE_NATURE,
  ARTICLE_STATUS,
  ARTICLE_TYPE,
  USER_TYPE,
  contentAddHost,
  contentRemoveStyle,
  getContentImages,
  lazyImages,
} from '@qcwp/common'
import { matchCarIndexOf, replaceCar } from './match'
import type { DailyCurrentArticle } from '~~/src/store'
import type {
  ArticleCarRefVO,
  ArticleDetailInfoVO,
  ArticleDetailResponse,
  ArticleWorkerVO,
  BindTopicsResponse,
} from '~~/src/server/modules/article/type'

export class ArticleDetailInfo implements ArticleDetailInfoVO {
  articleContent = ''
  metaDescription = ''
  metaKeyword = ''
  aiSummary = ''
  constructor(data?: ArticleDetailInfoVO) {
    if (!data)
      return
    this.articleContent = data.articleContent
    this.metaDescription = data.metaDescription
    this.metaKeyword = data.metaKeyword
    this.aiSummary = data.aiSummary

    // console.log('this.articleContent', this.articleContent)
  }

  splitKeyword(s = ',') {
    return isString(this.metaKeyword) ? this.metaKeyword.split(s) : []
  }
}
export class ArticleDetail implements ArticleDetailResponse {
  aiHelperType: '0' | '1' = '1'
  articleDetailInfoVO: ArticleDetailInfo = new ArticleDetailInfo()
  articleNature: ARTICLE_NATURE = ARTICLE_NATURE.ACTIVE
  articleStatus: ARTICLE_STATUS = ARTICLE_STATUS.REVIEWED
  articleTags: string[] = []
  articleType: ARTICLE_TYPE = ARTICLE_TYPE.PICTURE
  authorName = ''
  bindTopic = false
  porArticleCarRefList: ArticleCarRefVO[] = []
  collect = false
  commentCount = 0
  focus = false
  hot = false
  id = ''
  imgs: string[] = []
  contentImages: string[] = []
  linkUrl = ''
  look = 0
  // 媒体
  mediaAvatar = ''
  mediaGrade = '0'
  mediaName = ''
  mediaType: USER_TYPE = USER_TYPE.INDIVIDUAL
  mediaUserId = ''
  mediaIntro = ''
  payTime = 0
  showCreateTime = ''
  summary = ''

  sysUserId = ''
  sysUserName = ''
  articleWorkerVOList: ArticleWorkerVO[] = []
  title = ''
  top = false

  videoUrl = ''
  bindTopics: BindTopicsResponse[] = [] // 资讯绑定的专题

  // 小程序二维吗
  miniQrcode = ''
  updateTime = ''

  constructor(data?: ArticleDetailResponse) {
    if (!data)
      return
    this.aiHelperType = data.aiHelperType
    this.articleDetailInfoVO = new ArticleDetailInfo(data.articleDetailInfoVO)
    this.articleTags = data.articleTags
    this.sysUserId = data.sysUserId
    this.sysUserName = data.sysUserName
    this.payTime = data.payTime
    this.id = data.id
    this.title = data.title ?? ''
    this.summary = data.summary ?? ''
    this.linkUrl = data.linkUrl ?? '' // 视频地址
    this.videoUrl = data.linkUrl ?? '' // 重命名视频地址
    this.showCreateTime = data.showCreateTime ?? ''

    this.mediaAvatar = data.mediaAvatar ?? ''
    this.mediaName = data.mediaName ?? ''
    this.mediaUserId = data.mediaUserId ?? ''
    this.mediaIntro = data.mediaIntro ?? ''
    this.authorName = data.authorName ?? ''
    this.articleWorkerVOList = data.articleWorkerVOList ?? []

    this.articleTags = data.articleTags ?? []
    this.imgs = data.imgs ?? []

    this.look = isNumber(data.look) ? data.look : parseInt(data.look || '0')
    this.commentCount = isNumber(data.commentCount) ? data.commentCount : parseInt(data.commentCount || '0')

    this.focus = Boolean(data.focus) ?? false
    this.hot = Boolean(data.hot) ?? false
    this.top = Boolean(data.top) ?? false
    this.collect = Boolean(data.collect) ?? false

    this.articleNature = data.articleNature ?? ARTICLE_NATURE.ACTIVE
    this.articleStatus = data.articleStatus ?? ARTICLE_STATUS.REVIEWED
    this.articleType = data.articleType ?? ARTICLE_TYPE.PICTURE
    this.mediaType = data.mediaType ?? USER_TYPE.INDIVIDUAL
    this.porArticleCarRefList = data.porArticleCarRefList || []
    this.bindTopic = data.bindTopic || false
    this.mediaGrade = data.mediaGrade || '0'
    this.updateTime = data.updateTime ?? ''
  }

  matchSeries(content: string, porArticleCarRefList: ArticleCarRefVO[] = []): string {
    if (!content)
      return content
    try {
      const startTime = performance.now()
      // const result = matchCarIndexOf(content)
      const result = matchCarIndexOf(content, porArticleCarRefList)
      content = replaceCar(content, result)
      if (isClient)
        // eslint-disable-next-line no-console
        console.info('indexOf', `耗时${Math.ceil(performance.now() - startTime)}ms`, result)
    }
    catch (e) {
      recordError(e)
    }
    return content
  }

  formatContent() {
    let content = this.articleDetailInfoVO.articleContent || ''
    content = this.removeBrTag(content)
    content = contentRemoveStyle(contentAddHost(content))
    content = lazyImages(content)

    this.contentImages = getContentImages(content) || []
    return content
  }

  removeBrTag(str: string) {
    if (!isString(str))
      return str
    str = str.replace(/<p(.*?)><br>/gi, (substring) => {
      return substring.replace(/<br>/, '')
    })

    return str
  }

  setMiniQrcode(qrcode: string) {
    this.miniQrcode = qrcode
  }

  generateDailyData(): Omit<DailyCurrentArticle, 'isSwiper'> {
    const contentImgs = getContentImages(this.articleDetailInfoVO.articleContent || '') || []
    return {
      dataRefId: this.id,
      dataRefTitle: this.title,
      dataRefImgs: [...(this.imgs || []), ...contentImgs],
      dataRefType: '1',
      mediaUserVOList: [{
        mediaName: this.mediaName,
        mediaUserId: this.mediaUserId,
        mediaAvatar: this.mediaAvatar,
      }],
      look: this.look,
      articleType: this.articleType,
    }
  }
}
